import { render } from "./PhotoLongPressMenu.vue?vue&type=template&id=797cd117&scoped=true"
import script from "./PhotoLongPressMenu.vue?vue&type=script&lang=js"
export * from "./PhotoLongPressMenu.vue?vue&type=script&lang=js"

import "./PhotoLongPressMenu.vue?vue&type=style&index=0&id=797cd117&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-797cd117"]])

export default __exports__